import { GatheringStatus, SeasonStatus } from '../enums';

/**
 * Таблицы допустимых переходов состояний (BLUEPRINT 5, инварианты; Stage 5, задача 2).
 * Сервис сезонов проверяет переход через `canTransition` перед любой мутацией;
 * менять таблицы только здесь и с тестами.
 */

export const SEASON_TRANSITIONS: Readonly<Record<SeasonStatus, readonly SeasonStatus[]>> = {
  // DRAFT → ACTIVE напрямую: сезон для отряда, который уже запущен вручную (Stage 4)
  [SeasonStatus.DRAFT]: [SeasonStatus.SALE, SeasonStatus.ACTIVE, SeasonStatus.CANCELLED],
  [SeasonStatus.SALE]: [SeasonStatus.ACTIVE, SeasonStatus.CANCELLED],
  [SeasonStatus.ACTIVE]: [SeasonStatus.FINISHED, SeasonStatus.CANCELLED],
  [SeasonStatus.FINISHED]: [],
  [SeasonStatus.CANCELLED]: [],
};

export const GATHERING_TRANSITIONS: Readonly<Record<GatheringStatus, readonly GatheringStatus[]>> =
  {
    [GatheringStatus.PLANNED]: [GatheringStatus.CONFIRMED, GatheringStatus.CANCELLED],
    [GatheringStatus.CONFIRMED]: [GatheringStatus.DONE, GatheringStatus.CANCELLED],
    [GatheringStatus.DONE]: [],
    [GatheringStatus.CANCELLED]: [],
  };

export function canTransition<S extends string>(
  table: Readonly<Record<S, readonly S[]>>,
  from: S,
  to: S,
): boolean {
  return table[from].includes(to);
}

export function canSeasonTransition(from: SeasonStatus, to: SeasonStatus): boolean {
  return canTransition(SEASON_TRANSITIONS, from, to);
}

export function canGatheringTransition(from: GatheringStatus, to: GatheringStatus): boolean {
  return canTransition(GATHERING_TRANSITIONS, from, to);
}

/** Сезон ещё живой: можно править сборы и менять статус. */
export function isSeasonOpen(status: SeasonStatus): boolean {
  return SEASON_TRANSITIONS[status].length > 0;
}

/** Сбор ещё впереди: можно перенести, отменить, подтвердить. */
export function isGatheringOpen(status: GatheringStatus): boolean {
  return GATHERING_TRANSITIONS[status].length > 0;
}

export type GatheringCompleteBlock = 'season_not_active' | 'gathering_not_started';

/**
 * Почему сбор нельзя завершить (`null` — можно). Раунд 5, O1: `DONE` пересчитывает надёжность,
 * запускает продление и попадает в метрики дожития — поэтому только сбор идущего сезона и
 * только после начала (BLUEPRINT 5: `DONE` — после чек-ина). Одно правило для ops и капитана;
 * админка по нему же прячет кнопку «Завершить».
 */
export function gatheringCompleteBlock(
  seasonStatus: SeasonStatus,
  startsAt: Date,
  now: Date,
): GatheringCompleteBlock | null {
  if (seasonStatus !== SeasonStatus.ACTIVE) return 'season_not_active';
  if (now.getTime() < startsAt.getTime()) return 'gathering_not_started';
  return null;
}
